import ModalUploadFile from "./ModalUploadFile";

export default ModalUploadFile;
